
import React from 'react';
import StudentRegistrationForm from '../components/StudentRegistrationForm';

const StudentRegistration = () => {
  return <StudentRegistrationForm />;
};

export default StudentRegistration;
